var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2807.96 2800.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#91b3fa;}.cls-14,.cls-3,.cls-44{fill:#fff;}.cls-3{opacity:0.43;}.cls-4,.cls-8{fill:#bdd0fb;}.cls-5{opacity:0.3;}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{opacity:0.56;}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:#274f89;}.cls-11{fill:#5793ce;}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:#173d7a;}.cls-15{fill:#396caa;}.cls-16{fill:url(#linear-gradient-6);}.cls-17{fill:url(#linear-gradient-7);}.cls-18{fill:url(#linear-gradient-8);}.cls-19{fill:url(#linear-gradient-9);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:url(#linear-gradient-11);}.cls-22{fill:url(#linear-gradient-12);}.cls-23{fill:url(#linear-gradient-13);}.cls-24{fill:url(#linear-gradient-14);}.cls-25{fill:url(#linear-gradient-15);}.cls-26{fill:url(#linear-gradient-16);}.cls-27{fill:url(#linear-gradient-17);}.cls-28{fill:url(#linear-gradient-18);}.cls-29{fill:url(#linear-gradient-19);}.cls-30{fill:url(#linear-gradient-20);}.cls-31{fill:url(#linear-gradient-21);}.cls-32{fill:url(#linear-gradient-22);}.cls-33{fill:url(#linear-gradient-23);}.cls-34{fill:url(#linear-gradient-24);}.cls-35{fill:url(#linear-gradient-25);}.cls-36{fill:url(#linear-gradient-26);}.cls-37{fill:url(#linear-gradient-27);}.cls-38{fill:url(#linear-gradient-28);}.cls-39{fill:url(#linear-gradient-29);}.cls-40{fill:url(#linear-gradient-30);}.cls-41{fill:url(#linear-gradient-31);}.cls-42{fill:url(#linear-gradient-32);}.cls-43{fill:url(#linear-gradient-33);}.cls-44{opacity:0.37;}.cls-45{fill:url(#linear-gradient-34);}.cls-46{fill:url(#linear-gradient-35);}.cls-47{fill:url(#linear-gradient-36);}.cls-48{fill:url(#linear-gradient-37);}.cls-49{fill:url(#linear-gradient-38);}.cls-50{fill:url(#linear-gradient-39);}.cls-51{fill:url(#linear-gradient-40);}.cls-52{fill:url(#linear-gradient-41);}.cls-53{fill:url(#linear-gradient-42);}.cls-54{fill:url(#linear-gradient-43);}.cls-55{fill:url(#linear-gradient-44);}.cls-56{fill:url(#linear-gradient-45);}.cls-57{fill:url(#linear-gradient-46);}.cls-58{fill:url(#linear-gradient-47);}.cls-59{fill:url(#linear-gradient-48);}.cls-60{fill:url(#linear-gradient-49);}.cls-61{fill:url(#linear-gradient-50);}.cls-62{fill:url(#linear-gradient-51);}.cls-63{fill:url(#linear-gradient-52);}.cls-64{fill:url(#linear-gradient-53);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3639.03,
    y1: 3986.38,
    x2: 1166.78,
    y2: 916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 855.53,
    y1: 978.11,
    x2: 996.47,
    y2: 978.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 751.83,
    y1: 979.29,
    x2: 1098.38,
    y2: 979.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1252.59,
    y1: 661.13,
    x2: 1491.68,
    y2: 661.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 579.03,
    y1: 2495.27,
    x2: 3120.38,
    y2: 2495.27,
    gradientTransform: "matrix(1, -0.02, 0.02, 1, -34.65, 32.9)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2605.81,
    y1: 1487.55,
    x2: 2901.44,
    y2: 1487.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2718.22,
    y1: 1488.56,
    x2: 2788.9,
    y2: 1488.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2714.93,
    y1: 1488.56,
    x2: 2792.19,
    y2: 1488.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2654.02,
    y1: 1488.22,
    x2: 2845.82,
    y2: 1488.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2650.73,
    y1: 1488.22,
    x2: 2849.11,
    y2: 1488.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2638.03,
    y1: 1438.51,
    x2: 2868.49,
    y2: 1438.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2139.54,
    y1: 1066,
    x2: 2376.57,
    y2: 1066,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2671.42,
    y1: 1390.12,
    x2: 2835.09,
    y2: 1390.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2668.13,
    y1: 1390.12,
    x2: 2838.42,
    y2: 1390.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 2628.02,
    y1: 1486.9,
    x2: 2878.49,
    y2: 1486.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2129.54,
    y1: 1114.39,
    x2: 2386.6,
    y2: 1114.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 2638.03,
    y1: 1535.29,
    x2: 2868.49,
    y2: 1535.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 2139.54,
    y1: 1162.78,
    x2: 2376.57,
    y2: 1162.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 2675.22,
    y1: 1583.69,
    x2: 2839.57,
    y2: 1583.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2671.93,
    y1: 1583.69,
    x2: 2842.86,
    y2: 1583.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 2138.82,
    y1: 847.19,
    x2: 2358.47,
    y2: 847.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 2362.42,
    y1: 859.67,
    x2: 2454.01,
    y2: 859.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 2166.81,
    y1: 926.52,
    x2: 2207.69,
    y2: 926.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 2385.69,
    y1: 926.52,
    x2: 2426.66,
    y2: 926.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1473.87,
    y1: 723.44,
    x2: 1565.16,
    y2: 723.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1328.83,
    y1: 832.32,
    x2: 1672.92,
    y2: 832.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 957.23,
    y1: 1429.24,
    x2: 1135.22,
    y2: 1429.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1008.09,
    y1: 1459.62,
    x2: 1023.7,
    y2: 1459.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1067.42,
    y1: 1459.62,
    x2: 1083.03,
    y2: 1459.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 957.23,
    y1: 1483.89,
    x2: 1131.14,
    y2: 1483.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 949.9,
    y1: 1459.26,
    x2: 1141.23,
    y2: 1459.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 876.7,
    y1: 1433.41,
    x2: 970.07,
    y2: 1433.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 2950.41,
    y1: 2503.18,
    x2: 2802.5,
    y2: 3202.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 2864.07,
    y1: 2043.06,
    x2: 2850.63,
    y2: 2715.41,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 540.46,
    y1: 3467.75,
    x2: 661.05,
    y2: 2058.35,
    gradientTransform: "matrix(-1, 0, 0, 1, 1415.25, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 891.26,
    y1: 3061.81,
    x2: 1067.04,
    y2: 2809.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 632.01,
    y1: 3467.6,
    x2: 752.6,
    y2: 2058.19,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 596.79,
    y1: 3121.85,
    x2: 732.38,
    y2: 3121.85,
    gradientTransform: "matrix(-1, 0, 0, 1, 1415.25, 0)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 2218.93,
    y1: 2131.89,
    x2: 2019.24,
    y2: 2293.16,
    gradientTransform: "translate(-1636.62 344.84) rotate(-14.44)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 2196.31,
    y1: 429.34,
    x2: 1772.69,
    y2: 923.57,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1880.36,
    y1: 2257.4,
    x2: 1946.61,
    y2: 2404.38,
    gradientTransform: "translate(-1636.62 344.84) rotate(-14.44)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1764.15,
    y1: 2309.79,
    x2: 1830.4,
    y2: 2456.77,
    gradientTransform: "translate(-1636.62 344.84) rotate(-14.44)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 7652.42,
    y1: 2352.6,
    x2: 7603.94,
    y2: 2420.99,
    gradientTransform: "translate(-6838.69 3975.4) rotate(-32.44)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 7707.97,
    y1: 2314.63,
    x2: 7538.18,
    y2: 2554.19,
    gradientTransform: "translate(-6838.69 3975.4) rotate(-32.44)",
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 7696.28,
    y1: 2326.39,
    x2: 7559.5,
    y2: 2519.38,
    gradientTransform: "translate(-6838.69 3975.4) rotate(-32.44)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 7353.33,
    y1: 5923.08,
    x2: 7341.71,
    y2: 5939.48,
    gradientTransform: "matrix(0.72, -0.7, 0.37, 0.38, -6578.86, 4715.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d55d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c2873"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 7705.77,
    y1: 2336.85,
    x2: 7624.46,
    y2: 2451.57,
    gradientTransform: "translate(-6838.69 3975.4) rotate(-32.44)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1891.67,
    y1: 2253.39,
    x2: 2011.6,
    y2: 2030.66,
    gradientTransform: "translate(-1636.62 344.84) rotate(-14.44)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -295.33,
    y1: -2355.97,
    x2: -154.37,
    y2: -2260.23,
    gradientTransform: "matrix(-0.87, -0.49, -0.49, 0.87, -533.72, 3750.03)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1982.04,
    y1: 1985.53,
    x2: 1854.11,
    y2: 1770.78,
    gradientTransform: "translate(-1636.62 344.84) rotate(-14.44)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -286.88,
    y1: -2368.41,
    x2: -145.93,
    y2: -2272.67,
    gradientTransform: "matrix(-0.87, -0.49, -0.49, 0.87, -533.72, 3750.03)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1866.15,
    y1: 2054.57,
    x2: 1738.22,
    y2: 1839.83,
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 864.28,
    y1: 2269.68,
    x2: 679.39,
    y2: 2777.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2966.85,2770c-57.22,59.48-111.36,97.84-154.14,128.15-502.85,356.24-1097.85,252.4-1224.3,227-186.73-37.45-547.69-109.84-808.65-412.85C385,2253.92,446.43,1531.68,752.67,1054.91c56-87.21,351.91-571.23,953.32-648.85,364-47,788.24,47.77,1095.48,301.92C3446.4,1241.49,3400.49,2319.26,2966.85,2770Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3157.25,665.69c-4.43-14.81-25.83-13.83-28.82,1.34-29,146.67-116.93,528.9-281.92,741.05-268.64,345.43-423.08,884.14-213.38,1140.34C2633.13,2548.42,3640.53,2279.79,3157.25,665.69Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3145.07,872.68c0,4.72-.37,8.62-.58,12.82l-.9,12.39-2.08,24.72c-1.49,16.47-3.24,32.91-5,49.35q-5.43,49.29-12,98.46c-8.77,65.54-19.32,130.84-30.84,196s-24.69,130-39.31,194.49-30.28,128.83-48,192.6c-35.16,127.59-77.29,253.39-128.13,375.71-26.06,60.88-53.73,121.11-84.83,179.6C2762,2267,2728,2324,2690,2378.18a2.61,2.61,0,0,1-4.33-2.9l0,0a1919.22,1919.22,0,0,0,98.25-171.44c30-58.66,56.53-119,81.47-180s47.36-123,68.39-185.41,39.43-125.77,57.49-189.16c35.59-127,64.37-255.79,89.6-385.28q18.7-97.15,33.66-195,7.59-48.9,14.17-98l6.15-49.1,2.82-24.57,1.27-12.29c.36-4,.8-8.36,1-11.9l0-.58a2.59,2.59,0,0,1,5.17.11Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2634.31,379c-8.11-12.37-27.46-5.64-26.07,9.09,13.46,142.41,37.06,516.92-56.36,756.49-152.13,390.06-146.8,926.22,115.4,1104C2667.28,2248.5,3517.84,1727.33,2634.31,379Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2679.65,572.09c1.3,4.34,2,8,3,11.92l2.56,11.6,4.84,23.24c3.13,15.51,6,31.06,8.9,46.62q8.49,46.68,15.91,93.55c9.85,62.5,18,125.26,25.2,188.12s12.83,125.93,17,189.09,7.38,126.4,8.54,189.72c2.58,126.6-1.75,253.46-15,379.51-7.3,62.94-16.25,125.72-28.82,187.85-13,62-28.69,123.51-48.77,183.58a2.54,2.54,0,0,1-4.85-1.5v0a1838.19,1838.19,0,0,0,43.28-184c11.49-62,19.36-124.57,25.59-187.27s9.87-125.68,12.12-188.67,1.84-126.1,1.12-189.15c-2-126.14-10.75-252.13-22.92-377.75q-9.33-94.2-22.31-188-6.36-46.92-13.7-93.7l-7.75-46.7-4.11-23.31-2.18-11.61c-.78-3.79-1.55-7.89-2.36-11.17l-.14-.55a2.52,2.52,0,0,1,4.86-1.33Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1310.25,859.73a10.28,10.28,0,0,1,11.54,7.46c3,11.2,5.63,22.7,7.71,34.18a10.27,10.27,0,0,1-8.28,11.94l-.2,0a10.27,10.27,0,0,1-11.74-8.32c-2-10.9-4.44-21.83-7.32-32.47a10.26,10.26,0,0,1,7.23-12.6A10,10,0,0,1,1310.25,859.73Zm13.61,88.47a8.13,8.13,0,0,1,1.22-.12,10.27,10.27,0,0,1,10.7,9.82c.49,11.65.49,23.43,0,35a10.27,10.27,0,1,1-20.53-.87c.47-11,.47-22.21,0-33.28A10.28,10.28,0,0,1,1323.86,948.2Zm-6.2,89.26a10.28,10.28,0,0,1,11.74,12c-2.11,11.44-4.74,22.93-7.82,34.15a10.28,10.28,0,0,1-19.82-5.45c2.93-10.65,5.43-21.56,7.43-32.42A10.29,10.29,0,0,1,1317.66,1037.46Zm-26,85.65a10.28,10.28,0,0,1,11.06,14.22c-4.62,10.69-9.75,21.3-15.25,31.55a10.27,10.27,0,0,1-18.1-9.73c5.23-9.73,10.1-19.81,14.49-30A10.26,10.26,0,0,1,1291.64,1123.11Zm-44.46,77.7a10.28,10.28,0,0,1,9.93,16.21c-6.85,9.37-14.21,18.58-21.85,27.37a10.28,10.28,0,0,1-15.51-13.49c7.27-8.35,14.26-17.11,20.77-26A10.29,10.29,0,0,1,1247.18,1200.81Zm-60.54,65.92a10.28,10.28,0,0,1,8.4,17.89c-8.77,7.64-18,15-27.37,21.86a10.28,10.28,0,0,1-12.13-16.59c8.92-6.52,17.67-13.51,26-20.77A10.31,10.31,0,0,1,1186.64,1266.73Zm-367.77,84.16a10.17,10.17,0,0,1,4.34.23c10.65,2.91,21.57,5.39,32.45,7.37A10.27,10.27,0,1,1,852,1378.7c-11.46-2.08-23-4.69-34.18-7.75a10.28,10.28,0,0,1,1.07-20.06Zm294.18-33.32a10.28,10.28,0,0,1,6.49,19.2c-10.25,5.49-20.86,10.61-31.55,15.21a10.27,10.27,0,0,1-8.11-18.88c10.14-4.36,20.22-9.22,29.95-14.44A10.23,10.23,0,0,1,1113.05,1317.57Zm-205.73,47a10.05,10.05,0,0,1,2.06-.13c11,.45,22.24.43,33.3-.06a10.28,10.28,0,0,1,.91,20.53c-11.64.51-23.42.53-35,.06a10.27,10.27,0,0,1-1.23-20.4Zm122.62-13.88a10.28,10.28,0,0,1,4.33,20.06c-11.2,3-22.69,5.67-34.15,7.76l-.22,0a10.27,10.27,0,0,1-3.48-20.25c10.88-2,21.8-4.47,32.45-7.38A10.22,10.22,0,0,1,1029.94,1350.69Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M751.28,1325.67a10.24,10.24,0,0,1,6.07.88c4.78,2.3,9.68,4.53,14.57,6.64a10.27,10.27,0,1,1-8.13,18.86c-5.15-2.21-10.3-4.56-15.33-7a10.27,10.27,0,0,1,2.82-19.41Z",
    transform: "translate(-495.2 -372.51)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M544.26,1090.6a10.28,10.28,0,0,1,11.38,6.92c1.66,5,3.45,10.11,5.33,15.1a10.27,10.27,0,1,1-19.23,7.24c-2-5.25-3.86-10.6-5.61-15.89a10.27,10.27,0,0,1,6.53-13A10.08,10.08,0,0,1,544.26,1090.6Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M860,569.87q7-1.12,14.1-2a10.28,10.28,0,0,1,2.59,20.39c-10.91,1.39-21.74,3.21-32.31,5.45a10.27,10.27,0,1,1-4.26-20.1C846.61,572.2,853.3,571,860,569.87Zm68.25-5.17a10,10,0,0,1,1.74-.13c11.47.1,23,.69,34.44,1.76a10.27,10.27,0,1,1-1.92,20.45c-10.81-1-21.82-1.57-32.71-1.67a10.27,10.27,0,0,1-1.55-20.41ZM788.09,588.45a10.27,10.27,0,0,1,5.11,19.81c-10.21,3.68-20.41,7.85-30.3,12.4A10.28,10.28,0,0,1,754.32,602c10.42-4.78,21.15-9.17,31.91-13.05A10.17,10.17,0,0,1,788.09,588.45Zm227.58-13.24a10.31,10.31,0,0,1,4,.14c11.15,2.62,22.32,5.75,33.21,9.3a10.27,10.27,0,1,1-6.38,19.53c-10.33-3.37-20.94-6.34-31.53-8.82a10.28,10.28,0,0,1,.72-20.15ZM709.1,627.3a10.28,10.28,0,0,1,7.17,18.81c-9.15,5.83-18.17,12.14-26.83,18.75A10.27,10.27,0,0,1,677,648.53c9.11-7,18.61-13.6,28.24-19.75A10.47,10.47,0,0,1,709.1,627.3Zm-68.55,55.24a10.28,10.28,0,0,1,8.93,17.39c-7.67,7.72-15.11,15.85-22.1,24.16a10.27,10.27,0,1,1-15.73-13.22c7.36-8.75,15.18-17.31,23.26-25.43A10.22,10.22,0,0,1,640.55,682.54Zm-54.88,68.88A10.28,10.28,0,0,1,596,767.05c-5.81,9.21-11.3,18.76-16.31,28.4A10.27,10.27,0,0,1,561.45,786c5.27-10.14,11-20.2,17.16-29.89A10.23,10.23,0,0,1,585.67,751.42Zm-38.55,79.2a10.1,10.1,0,0,1,5.08.47,10.27,10.27,0,0,1,6.23,13.12c-3.66,10.26-6.92,20.78-9.69,31.28a10.27,10.27,0,1,1-19.87-5.24c2.92-11.06,6.35-22.15,10.2-32.94A10.28,10.28,0,0,1,547.12,830.62Zm-20.23,85.76a10.29,10.29,0,0,1,11.84,11.38c-1.3,10.78-2.16,21.75-2.55,32.63a10.27,10.27,0,1,1-20.53-.74c.41-11.45,1.31-23,2.69-34.36A10.27,10.27,0,0,1,526.89,916.38Zm-.89,88,.63-.08a10.27,10.27,0,0,1,11.24,9.2c.79,8,1.84,16,3.11,23.91.47,2.85,1,5.7,1.48,8.53a10.27,10.27,0,0,1-8.25,12,10.15,10.15,0,0,1-12-8.24q-.82-4.47-1.55-9c-1.34-8.3-2.44-16.76-3.28-25.14A10.28,10.28,0,0,1,526,1004.43Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1098.9,604.83a10.35,10.35,0,0,1,6.12.9c5,2.44,10,5,15,7.69a10.27,10.27,0,0,1-9.74,18.09c-4.7-2.53-9.5-5-14.25-7.3a10.27,10.27,0,0,1,2.87-19.38Z",
    transform: "translate(-495.2 -372.51)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1104.2,724.69a4.8,4.8,0,0,0-5.54-.6l-50.94,28.66a254.4,254.4,0,0,0-77.92-27l-22.27-54a4.81,4.81,0,0,0-4.72-3l-70,4.14a4.8,4.8,0,0,0-4.34,3.5l-15.75,56.24a254.43,254.43,0,0,0-74.19,36l-54-22.45a4.81,4.81,0,0,0-5.44,1.24L672.6,799.89a4.81,4.81,0,0,0-.6,5.54l28.66,50.94a254.49,254.49,0,0,0-27,77.92l-54,22.27a4.81,4.81,0,0,0-3,4.72l4.14,70a4.81,4.81,0,0,0,3.5,4.34l56.24,15.74a254.43,254.43,0,0,0,36,74.19l-22.45,54a4.78,4.78,0,0,0,1.25,5.43l52.41,46.55a4.79,4.79,0,0,0,5.54.6l50.94-28.66a254.49,254.49,0,0,0,77.92,27l22.27,54a4.8,4.8,0,0,0,4.72,3l70-4.15a4.81,4.81,0,0,0,4.34-3.5l15.74-56.24a254.43,254.43,0,0,0,74.19-36l54,22.45a4.8,4.8,0,0,0,5.44-1.24l46.55-52.42a4.8,4.8,0,0,0,.6-5.54l-28.66-50.94a254.4,254.4,0,0,0,27-77.92l54-22.27a4.78,4.78,0,0,0,3-4.72l-4.14-70a4.78,4.78,0,0,0-3.5-4.34l-56.24-15.75a254.43,254.43,0,0,0-36-74.19l22.45-54a4.8,4.8,0,0,0-1.24-5.44Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M914.81,908.51a70.55,70.55,0,1,1-10.06,2.4A71.3,71.3,0,0,1,914.81,908.51Zm19.69,122.94a54,54,0,1,0-33.4-5.41A53.84,53.84,0,0,0,934.5,1031.45Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M897.17,808.27a175.43,175.43,0,0,1,17.7-1.95h0q2.82-.17,5.64-.24a174.3,174.3,0,0,1,27.71,1.45l.38.05,1.06.15,2.06.31a4.12,4.12,0,0,1,3.43,3.4,4,4,0,0,1,0,1.29,4.11,4.11,0,0,1-4.69,3.43,165.26,165.26,0,0,0-169.61,83A164,164,0,0,0,760.35,989a168.49,168.49,0,0,0,1.85,16.88A165.09,165.09,0,0,0,934.86,1144c90.88-5.39,160.38-83.66,155-174.51a164.88,164.88,0,0,0-28.35-83.22,4,4,0,0,1-.66-1.66,4.11,4.11,0,0,1,7.45-3,173.44,173.44,0,0,1,29.77,87.37c5.65,95.37-67.38,177.55-162.73,183.2a173.33,173.33,0,0,1-181.25-145q-1.41-8.76-2-17.73a173.29,173.29,0,0,1,145-181.25Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1613.22,536.56a6.34,6.34,0,0,1,6.73,3.53c2.33,4.86,4.53,9.86,6.56,14.86a6.35,6.35,0,0,1-11.76,4.77c-1.93-4.76-4-9.52-6.25-14.16a6.35,6.35,0,0,1,3-8.46A6.65,6.65,0,0,1,1613.22,536.56Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1630.13,582.35a6.35,6.35,0,0,1,7.13,4.63,273.7,273.7,0,0,1,5.84,27.29q.48,2.9.88,5.81a6.57,6.57,0,0,1-5.41,7.17,6.34,6.34,0,0,1-7.16-5.4q-.39-2.79-.83-5.55a263.37,263.37,0,0,0-5.58-26,6.35,6.35,0,0,1,4.49-7.77C1629.7,582.43,1629.92,582.39,1630.13,582.35Zm9.12,65.26a6.84,6.84,0,0,1,.91-.09,6.36,6.36,0,0,1,6.45,6.24,273.19,273.19,0,0,1-1.49,33.74,6.35,6.35,0,0,1-12.62-1.34,261.73,261.73,0,0,0,1.42-32.18A6.34,6.34,0,0,1,1639.25,647.61Zm-7,65.51a6.55,6.55,0,0,1,2.45.09,6.34,6.34,0,0,1,4.73,7.63,273,273,0,0,1-9.74,32.36,6.35,6.35,0,0,1-11.91-4.4,262.61,262.61,0,0,0,9.3-30.86A6.34,6.34,0,0,1,1632.28,713.12Zm-22.87,61.8a6.35,6.35,0,0,1,6.64,9.19,274.19,274.19,0,0,1-17.37,29,6.34,6.34,0,1,1-10.46-7.18,263,263,0,0,0,16.56-27.64A6.33,6.33,0,0,1,1609.41,774.92Zm-37.27,54.34a6.35,6.35,0,0,1,5.77,10.47A277.28,277.28,0,0,1,1554,863.61a6.34,6.34,0,1,1-8.41-9.5,264.71,264.71,0,0,0,22.77-22.79A6.35,6.35,0,0,1,1572.14,829.26Zm-49.32,43.64a6.35,6.35,0,0,1,4.61,11.5,274.81,274.81,0,0,1-29,17.34,6.35,6.35,0,1,1-5.83-11.28,260.63,260.63,0,0,0,27.61-16.53A6.37,6.37,0,0,1,1522.82,872.9Zm-58.48,30.25a6.35,6.35,0,0,1,3.2,12.22,274.44,274.44,0,0,1-32.35,9.71,6.35,6.35,0,0,1-2.9-12.36,260.52,260.52,0,0,0,30.86-9.26A7.74,7.74,0,0,1,1464.34,903.15Zm-97.13,16.5a5.91,5.91,0,0,1,1.12-.08,260.29,260.29,0,0,0,28-1.07c1.41-.12,2.8-.26,4.18-.41a6.36,6.36,0,0,1,7,5.63,6.28,6.28,0,0,1-5.63,7c-1.47.16-2.94.31-4.43.44a276.82,276.82,0,0,1-29.32,1.11,6.35,6.35,0,0,1-.92-12.61Z",
    transform: "translate(-495.2 -372.51)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1325.21,388.26a6.35,6.35,0,0,1,2.1,12.52,261,261,0,0,0-30.82,7.33,6.35,6.35,0,1,1-3.68-12.15,278,278,0,0,1,32.31-7.69Zm32.26-3.66c.22,0,.45-.06.68-.07a277,277,0,0,1,33.23.23,6.35,6.35,0,0,1-.85,12.67,266.24,266.24,0,0,0-31.71-.23,6.35,6.35,0,0,1-1.35-12.6Zm-94.27,22.46a6.34,6.34,0,0,1,3.58,12.06,265.56,265.56,0,0,0-28.14,14.58,6.35,6.35,0,0,1-6.51-10.9,275.32,275.32,0,0,1,29.51-15.27A6.07,6.07,0,0,1,1263.2,407.06Zm159-18.07a6.32,6.32,0,0,1,2.21,0,272.38,272.38,0,0,1,32.2,8.25,6.35,6.35,0,1,1-3.89,12.08,260.83,260.83,0,0,0-30.71-7.87,6.34,6.34,0,0,1,.19-12.49Zm-214.56,51.3a6.35,6.35,0,0,1,4.91,11.28,259.66,259.66,0,0,0-23.81,20.9,6.35,6.35,0,1,1-8.94-9,273.31,273.31,0,0,1,25-21.92A6.22,6.22,0,0,1,1207.59,440.29Zm-46,45.6a6.35,6.35,0,0,1,6,10.2,265.25,265.25,0,0,0-18.14,26,6.34,6.34,0,1,1-10.83-6.61,277.47,277.47,0,0,1,19-27.26A6.27,6.27,0,0,1,1161.56,485.89Zm-33.78,55.32a6.35,6.35,0,0,1,6.79,8.9,259.28,259.28,0,0,0-11.37,29.59,6.34,6.34,0,0,1-12.1-3.82,274.53,274.53,0,0,1,11.91-31A6.38,6.38,0,0,1,1127.78,541.21Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1484.12,409a6.39,6.39,0,0,1,3.68.51c4.93,2.29,9.81,4.74,14.51,7.27a6.34,6.34,0,1,1-6,11.17c-4.48-2.41-9.14-4.74-13.84-6.93a6.35,6.35,0,0,1,1.67-12Z",
    transform: "translate(-495.2 -372.51)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1492,490.76a3.22,3.22,0,0,0-3.71-.4l-34.08,19.18A170.41,170.41,0,0,0,1402,491.45l-14.9-36.13a3.2,3.2,0,0,0-3.16-2l-46.83,2.77a3.2,3.2,0,0,0-2.9,2.34l-10.54,37.63a170.75,170.75,0,0,0-49.65,24.12l-36.1-15a3.22,3.22,0,0,0-3.64.83l-31.15,35.07a3.22,3.22,0,0,0-.4,3.71l19.17,34.09A170.52,170.52,0,0,0,1203.85,631l-36.13,14.9a3.23,3.23,0,0,0-2,3.16l2.77,46.83a3.19,3.19,0,0,0,2.34,2.9l37.64,10.54A170.6,170.6,0,0,0,1232.6,759l-15,36.11a3.21,3.21,0,0,0,.84,3.63l35.07,31.15a3.22,3.22,0,0,0,3.71.4l34.08-19.17a170.58,170.58,0,0,0,52.15,18.09l14.9,36.13a3.22,3.22,0,0,0,3.16,2l46.83-2.77a3.21,3.21,0,0,0,2.9-2.34l10.54-37.64a170.29,170.29,0,0,0,49.64-24.11l36.11,15a3.22,3.22,0,0,0,3.64-.83l31.15-35.08a3.22,3.22,0,0,0,.4-3.71l-19.18-34.08a170.26,170.26,0,0,0,18.09-52.14l36.13-14.91a3.19,3.19,0,0,0,2-3.16L1577,624.75a3.22,3.22,0,0,0-2.34-2.91L1537,611.31a170.25,170.25,0,0,0-24.12-49.65l15-36.11a3.21,3.21,0,0,0-.83-3.64Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1365.18,612.92a48,48,0,1,1-6.92,1.64A48.26,48.26,0,0,1,1365.18,612.92Zm13.16,82.27a35.31,35.31,0,1,0-16.26-68.53h0a35.31,35.31,0,0,0,16.26,68.53Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1353,543.13a120.63,120.63,0,0,1,36.42-.31l1.08.17a6.34,6.34,0,1,1-1.94,12.54,107.18,107.18,0,0,0-22.72-1.06h0l-1.25.08a105.83,105.83,0,0,0-49.72,16.32,107.3,107.3,0,0,0-22,18.58l-.16.18-.49.54a106.85,106.85,0,1,0,186.54,64.64,107.65,107.65,0,0,0-1.18-10.78,106.54,106.54,0,0,0-17.17-43.09,6.27,6.27,0,0,1-1-2.56,6.34,6.34,0,0,1,11.5-4.59,119.26,119.26,0,0,1,19.22,48.2q1,6,1.33,12.07a119.55,119.55,0,0,1-237.32,26.36A119.73,119.73,0,0,1,1353,543.13Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1149.28 2122.58 1092.91 2628.12 1746.89 2628.12 1661.71 2122.58 1149.28 2122.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M495.22,1237.82,516.77,2429A180.74,180.74,0,0,0,696.09,2606.5c435.29,3.35,1957.51,3,2371.57-10.58a133,133,0,0,0,128.57-131.54c3-276.88,3.91-942.57-49.68-1250.65a136.84,136.84,0,0,0-132.92-113.44c-364.76-5.07-1978.56-12.92-2392.38,3.87A131.37,131.37,0,0,0,495.22,1237.82Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M569.86,1230.67,590.34,2362.4a104.71,104.71,0,0,0,105,102.82L3005.45,2452A101.9,101.9,0,0,0,3107,2348.6l-16.42-1121.69a74.54,74.54,0,0,0-74.06-73.46l-2365.44-5A80.77,80.77,0,0,0,569.86,1230.67Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3127.11,2496.68H3127l-2534.29,2.67a3.72,3.72,0,0,1,0-7.43L3127,2489.25a3.72,3.72,0,0,1,.08,7.43Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2383,3104.07H1425.82c-26,0-45.53-18.52-40.51-38.4l12.29-48.57c3.69-14.61,19.76-25.33,38.85-25.93l922.71-28.79c19.94-.62,37.6,10,41.94,25.14l22.14,77.37C2429,3085,2409.37,3104.07,2383,3104.07Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1374.12,2265.51l-413.53-.66c-6.75,0-12.22-5-12.22-11.21v-26.31c0-6.18,5.47-11.16,12.22-11.13l413.53,2.32c6.28,0,11.36,4.9,11.36,10.86v25.36C1385.48,2260.69,1380.4,2265.52,1374.12,2265.51Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M976.62,2274.76l35.55,130.39c2.25,8.24,10.31,13.94,19.54,13.84L1307,2415.9c8.8-.1,16.46-5.84,18.59-13.91l33.53-126.93Zm102.05,122.74c0,5.17-4.53,9.41-10.13,9.47l-9.66.1c-5.61.06-10.16-4.1-10.16-9.29V2296.73c0-5.19,4.55-9.39,10.16-9.39h9.66c5.6,0,10.13,4.19,10.13,9.37Zm53.73-.51c0,5.15-4.5,9.37-10,9.43l-9.58.1c-5.55.05-10.06-4.09-10.06-9.25v-100.6c0-5.16,4.51-9.35,10.06-9.35h9.58c5.54,0,10,4.17,10,9.32Zm53.24-.51c0,5.13-4.45,9.33-9.94,9.39l-9.5.1c-5.5.05-10-4.07-10-9.21V2296.61c0-5.13,4.47-9.3,10-9.3h9.5c5.49,0,9.94,4.16,9.94,9.28Zm52.77-.5c0,5.11-4.41,9.29-9.85,9.35l-9.41.09c-5.46.06-9.89-4-9.89-9.16v-99.7c0-5.12,4.43-9.27,9.89-9.27h9.41c5.44,0,9.85,4.13,9.85,9.24Zm52.31-.49c0,5.08-4.38,9.24-9.77,9.3l-9.33.09a9.4,9.4,0,0,1-9.8-9.12V2296.5c0-5.09,4.39-9.22,9.8-9.22H1281c5.39,0,9.77,4.12,9.77,9.2Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1023.08,2203.29a16,16,0,0,1-21.31-1.5,13.13,13.13,0,0,1,1.47-19.62,16,16,0,0,1,21.3,1.53A13.14,13.14,0,0,1,1023.08,2203.29Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1155.79,2079.4c-2.08-2.25-6.36-2-9.57.54l-130.94,104c-3.29,2.61-4.23,6.56-2.11,8.82s6.5,2,9.78-.64l130.77-104C1156.93,2085.54,1157.86,2081.65,1155.79,2079.4Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1315.23,2205.25a14.9,14.9,0,0,0,20.21-1.18,13,13,0,0,0-1.38-19.1,14.9,14.9,0,0,0-20.22,1.14A13.05,13.05,0,0,0,1315.23,2205.25Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1186.08,2079.92c2.06-2.17,6.31-1.78,9.5.87l127.07,105.69c3.12,2.6,4,6.45,2,8.62s-6.18,1.82-9.3-.77l-127.22-105.67C1184.94,2086,1184,2082.09,1186.08,2079.92Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 2753.18,
    cy: 1484.75,
    r: 213.33,
    transform: "translate(-738.69 2009.16) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2754.71,1625.74c-2.37,0-4.74,0-7.13-.16-81.43-3.59-145-68.42-141.65-144.53,1.62-37,18.59-71.09,47.8-96,29-24.68,66.65-37.3,105.93-35.59,81.44,3.59,145,68.43,141.66,144.54h0c-1.62,37-18.6,71.08-47.8,95.94C2826.28,1613.18,2791.42,1625.74,2754.71,1625.74Zm-2.16-256.91c-32.1,0-62.5,10.93-86.2,31.11-25,21.31-39.58,50.42-40.95,82-2.86,65.39,52.33,121.12,123,124.23,34.37,1.49,67.22-9.48,92.45-31,25-21.32,39.58-50.42,41-82,2.86-65.38-52.34-121.11-123-124.23Q2755.68,1368.84,2752.55,1368.83Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2788.9,1488.17a388.63,388.63,0,0,1-5.56,67.68c-1,5.58-2.17,11.13-3.56,16.63a158.06,158.06,0,0,1-5,16.27,76.61,76.61,0,0,1-7.42,15.33,30.74,30.74,0,0,1-5.57,6.53,16.3,16.3,0,0,1-3.65,2.36,11,11,0,0,1-4.26,1,10.71,10.71,0,0,1-4.3-.8,14.71,14.71,0,0,1-3.74-2.23,28.73,28.73,0,0,1-5.69-6.42,74.56,74.56,0,0,1-7.53-15.28,155,155,0,0,1-5-16.26c-1.41-5.5-2.59-11-3.6-16.62-2-11.16-3.41-22.42-4.34-33.71s-1.39-22.63-1.45-34c0-5.67.13-11.33.33-17s.52-11.32.94-17c.83-11.3,2.08-22.57,3.93-33.75.93-5.59,2-11.16,3.32-16.67a162.18,162.18,0,0,1,4.71-16.34c1-2.67,2-5.32,3.17-7.9a58.32,58.32,0,0,1,4.05-7.5,27.91,27.91,0,0,1,5.57-6.46,14.18,14.18,0,0,1,3.68-2.21,10.4,10.4,0,0,1,4.23-.76,11,11,0,0,1,4.19,1,16.26,16.26,0,0,1,3.63,2.27,31.22,31.22,0,0,1,5.69,6.35,76.4,76.4,0,0,1,7.8,15.11,155.6,155.6,0,0,1,5.35,16.14c1.51,5.46,2.78,11,3.89,16.55A356.53,356.53,0,0,1,2788.9,1488.17Zm-1.67,0c0-11.29-.4-22.58-1.34-33.83a326.52,326.52,0,0,0-4.4-33.55c-1-5.54-2.24-11.06-3.68-16.51a155.17,155.17,0,0,0-5.14-16.09,75.39,75.39,0,0,0-7.56-15,30.61,30.61,0,0,0-5.5-6.29,16.21,16.21,0,0,0-3.49-2.24,10.44,10.44,0,0,0-4-1,9.56,9.56,0,0,0-4,.76,13.5,13.5,0,0,0-3.51,2.16,27.42,27.42,0,0,0-5.37,6.38,57.45,57.45,0,0,0-3.92,7.45c-1.14,2.57-2.14,5.2-3.05,7.87a157.52,157.52,0,0,0-4.51,16.28c-1.24,5.51-2.26,11.06-3.12,16.63-1.73,11.16-2.85,22.4-3.56,33.67s-1,22.56-.94,33.85.35,22.57,1.18,33.83,2.13,22.48,4.06,33.59c1,5.56,2.1,11.09,3.45,16.56a156.65,156.65,0,0,0,4.87,16.17A74.51,74.51,0,0,0,2741,1604a28.34,28.34,0,0,0,5.45,6.24,14.08,14.08,0,0,0,3.49,2.13,9.7,9.7,0,0,0,3.94.75,10,10,0,0,0,3.9-1,15,15,0,0,0,3.41-2.25,29.76,29.76,0,0,0,5.34-6.36,76.66,76.66,0,0,0,7.19-15.17,159.21,159.21,0,0,0,4.81-16.19c1.34-5.47,2.45-11,3.41-16.56,1.92-11.12,3.19-22.35,4-33.6S2787.24,1499.46,2787.23,1488.17Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2753.58,1617.28a13.87,13.87,0,0,1-5.21-1,17.75,17.75,0,0,1-4.55-2.7,31.46,31.46,0,0,1-6.36-7.15,77.56,77.56,0,0,1-7.9-16,160.65,160.65,0,0,1-5.14-16.61c-1.35-5.3-2.54-10.81-3.65-16.85-1.94-10.69-3.37-21.82-4.38-34-.91-11.09-1.4-22.6-1.45-34.21,0-6.07.14-12.06.32-17.13.22-5.75.54-11.51.95-17.09.9-12.28,2.2-23.41,4-34,1-6.07,2.11-11.59,3.36-16.9a165.41,165.41,0,0,1,4.81-16.67c1.08-3,2.15-5.7,3.28-8.17a61.74,61.74,0,0,1,4.28-7.93,30.82,30.82,0,0,1,6.25-7.22,17.57,17.57,0,0,1,4.55-2.72,13.73,13.73,0,0,1,5.57-1,14.64,14.64,0,0,1,5.38,1.26,20,20,0,0,1,4.38,2.73,33.9,33.9,0,0,1,6.31,7,78.64,78.64,0,0,1,8.16,15.76,156.37,156.37,0,0,1,5.47,16.5c1.47,5.31,2.75,10.8,3.94,16.79,4.15,21.13,6.2,43.45,6.27,68.24h0c0,24.94-1.87,47.27-5.61,68.26-1.09,6-2.27,11.54-3.61,16.86a164.47,164.47,0,0,1-5.08,16.61,80.2,80.2,0,0,1-7.76,16,33.4,33.4,0,0,1-6.2,7.23,19.62,19.62,0,0,1-4.41,2.85,14.13,14.13,0,0,1-5.56,1.3ZM2751.87,1367a6.54,6.54,0,0,0-2.5.51,10.48,10.48,0,0,0-2.67,1.66,23.76,23.76,0,0,0-4.69,5.61,54.05,54.05,0,0,0-3.69,7c-1,2.28-2,4.77-2.94,7.6a153.22,153.22,0,0,0-4.41,15.94c-1.16,5.16-2.17,10.53-3.08,16.41-1.62,10.44-2.77,21.36-3.52,33.37-.66,10.26-1,21.26-.94,33.63,0,11.41.36,22.71,1.17,33.59.89,12,2.21,22.83,4,33.28,1,5.84,2.13,11.18,3.41,16.32a149.38,149.38,0,0,0,4.76,15.82,69.61,69.61,0,0,0,7,14.44,24.52,24.52,0,0,0,4.77,5.51,10.87,10.87,0,0,0,2.65,1.63,6.87,6.87,0,0,0,2.6.51,6.58,6.58,0,0,0,2.63-.66,11.38,11.38,0,0,0,2.65-1.76,26,26,0,0,0,4.72-5.65,72.18,72.18,0,0,0,6.86-14.51,155,155,0,0,0,4.71-15.84c1.25-5.12,2.35-10.46,3.36-16.34,1.79-10.35,3.1-21.23,4-33.28.83-10.85,1.25-22.15,1.24-33.58h0c0-11.38-.42-22.67-1.33-33.54a320.52,320.52,0,0,0-4.35-33.22c-1.08-5.79-2.27-11.11-3.63-16.27a149.82,149.82,0,0,0-5-15.75,71.58,71.58,0,0,0-7.21-14.38,26.88,26.88,0,0,0-4.88-5.6,12.7,12.7,0,0,0-2.75-1.77,7,7,0,0,0-2.71-.68Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M2845.82,1488.17a165.45,165.45,0,0,1-5.83,43.25,139.56,139.56,0,0,1-18,39.65A114.26,114.26,0,0,1,2808.2,1588a97.08,97.08,0,0,1-16.95,13.69,82,82,0,0,1-19.77,9.08,73.68,73.68,0,0,1-43,0,81.11,81.11,0,0,1-19.79-9.06,96.25,96.25,0,0,1-17-13.68,114.26,114.26,0,0,1-13.79-16.92,139.38,139.38,0,0,1-18.07-39.67,157,157,0,0,1-4.38-21.44,162.43,162.43,0,0,1,0-43.68,158.12,158.12,0,0,1,4.39-21.43,139.77,139.77,0,0,1,18.1-39.65,114.22,114.22,0,0,1,13.79-16.9,96.5,96.5,0,0,1,17-13.66,82,82,0,0,1,19.77-9,73.15,73.15,0,0,1,42.93,0,81.71,81.71,0,0,1,19.75,9,96.44,96.44,0,0,1,16.94,13.67,114,114,0,0,1,13.77,16.91,139.37,139.37,0,0,1,18.05,39.63A165.29,165.29,0,0,1,2845.82,1488.17Zm-1.91,0a163.87,163.87,0,0,0-5.6-42.78,138.92,138.92,0,0,0-17.45-39.39,112.21,112.21,0,0,0-13.46-16.87,93.85,93.85,0,0,0-16.64-13.7,80.21,80.21,0,0,0-19.52-9.06,71.31,71.31,0,0,0-42.5,0,80,80,0,0,0-19.51,9.07,94.13,94.13,0,0,0-16.62,13.71,112.54,112.54,0,0,0-13.42,16.88,138.54,138.54,0,0,0-17.41,39.37,157.81,157.81,0,0,0-4.18,21.19,164.88,164.88,0,0,0,0,43.11,159.13,159.13,0,0,0,4.2,21.19,138.57,138.57,0,0,0,17.43,39.34,112.44,112.44,0,0,0,13.43,16.86,93.54,93.54,0,0,0,16.61,13.68,80.5,80.5,0,0,0,19.49,9,70.66,70.66,0,0,0,42.43,0,80.57,80.57,0,0,0,19.51-9,94.1,94.1,0,0,0,16.64-13.68,113.13,113.13,0,0,0,13.45-16.85,138.82,138.82,0,0,0,17.48-39.36A163.83,163.83,0,0,0,2843.91,1488.17Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2750,1617.28a77.76,77.76,0,0,1-22.45-3.33,85,85,0,0,1-20.59-9.43,100.37,100.37,0,0,1-17.55-14.15,118.39,118.39,0,0,1-14.19-17.41,142.44,142.44,0,0,1-18.51-40.61,161.39,161.39,0,0,1-4.47-21.91,165.6,165.6,0,0,1,0-44.55,161.9,161.9,0,0,1,4.49-21.88,142.44,142.44,0,0,1,18.53-40.6,116.88,116.88,0,0,1,14.2-17.39,99.18,99.18,0,0,1,17.54-14.13,85.2,85.2,0,0,1,20.57-9.39,76.45,76.45,0,0,1,44.83,0,85.28,85.28,0,0,1,20.55,9.4,100,100,0,0,1,17.52,14.14,118,118,0,0,1,14.17,17.4,142.26,142.26,0,0,1,18.48,40.57,168.53,168.53,0,0,1,6,44.12v0a168.92,168.92,0,0,1-6,44.11,142.49,142.49,0,0,1-18.47,40.61,117.56,117.56,0,0,1-14.16,17.42,100.77,100.77,0,0,1-17.53,14.16,85.25,85.25,0,0,1-20.57,9.44A78,78,0,0,1,2750,1617.28Zm0-250.84a70.32,70.32,0,0,0-20.28,3.1,77.62,77.62,0,0,0-18.71,8.71,90.63,90.63,0,0,0-16,13.23,109.6,109.6,0,0,0-13,16.38,135.51,135.51,0,0,0-17,38.43,155.5,155.5,0,0,0-4.09,20.75,161.88,161.88,0,0,0,0,42.26A155.82,155.82,0,0,0,2665,1530a135,135,0,0,0,17,38.41,109.24,109.24,0,0,0,13,16.36,90.47,90.47,0,0,0,16,13.21,77.38,77.38,0,0,0,18.68,8.67,67.51,67.51,0,0,0,40.51,0A78,78,0,0,0,2789,1598a90.73,90.73,0,0,0,16-13.2,110,110,0,0,0,13.06-16.36,135.2,135.2,0,0,0,17.05-38.42,162.49,162.49,0,0,0,0-83.8,135.32,135.32,0,0,0-17-38.45,110.61,110.61,0,0,0-13.06-16.38,90.51,90.51,0,0,0-16.06-13.21,76.64,76.64,0,0,0-18.71-8.69A70.34,70.34,0,0,0,2750,1366.44Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M2638.15,1438.38l28.78-.23,28.78-.13,57.56-.11,57.57.12,28.78.14,28.78.25a.09.09,0,0,1,.09.09s0,.08-.09.08l-28.78.26-28.78.14-57.57.12-57.56-.11-28.78-.13-28.78-.23a.24.24,0,0,1-.12-.06C2638,1438.44,2638.08,1438.38,2638.15,1438.38Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "2258.08 1069.9 2171.72 1069.66 2141.56 1069.41 2139.54 1067.4 2139.54 1065.92 2139.61 1062.7 2142.93 1062.57 2200.5 1062.2 2258.07 1062.1 2344.44 1062.36 2376.49 1062.64 2376.57 1069.3 2373.2 1069.38 2315.66 1069.78 2258.08 1069.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2671.54,1390c6.81-.11,13.62-.15,20.43-.23l20.44-.14c6.81,0,13.62,0,20.43-.06l20.43,0,40.87.11,20.44.15c6.81.08,13.62.14,20.43.25a.11.11,0,0,1,.08,0c0,.09,0,.13-.08.13-6.81.12-13.62.17-20.43.25l-20.44.15-40.87.11-20.43,0c-6.81,0-13.62,0-20.43-.07l-20.44-.13c-6.81-.08-13.62-.13-20.43-.24a.12.12,0,0,1-.12-.13A.12.12,0,0,1,2671.54,1390Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M2753.29,1394l-25.75,0c-5.05,0-10.11,0-15.16-.06l-27.25-.21c-4.55,0-9.09-.08-13.64-.16l-3.24,0-.12-6.68,3.36-.12c4.4-.07,8.8-.11,13.2-.16l27.7-.21q7.18-.06,14.39,0l26.49,0,68.77.34c4.34,0,8.69.09,13,.17l3.35.06-.15,6.63-3.26.08c-4.49.08-9,.13-13.59.18l-27.25.22Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M2628.15,1486.78l31.28-.24,31.28-.13,62.56-.11,62.57.12,31.28.15,31.28.25a.09.09,0,0,1,.09.08s0,.09-.09.09l-31.28.25-31.28.14-62.57.12-62.56-.11-31.28-.13-31.28-.23a.13.13,0,0,1-.13-.13A.12.12,0,0,1,2628.15,1486.78Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "2258.08 1118.29 2164.22 1118.05 2129.66 1117.8 2129.54 1111.09 2132.93 1110.96 2195.5 1110.6 2258.07 1110.49 2351.94 1110.76 2384.61 1111.02 2386.6 1113.04 2386.47 1117.69 2383.2 1117.78 2320.66 1118.17 2258.08 1118.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M2638.15,1535.17l28.78-.23,28.78-.14,57.56-.1,57.57.11,28.78.15,28.78.25a.14.14,0,0,1,.09,0c0,.09,0,.13-.09.13l-28.78.25-28.78.15-57.57.11-57.56-.1-28.78-.14-28.78-.23a.12.12,0,0,1-.12-.13A.12.12,0,0,1,2638.15,1535.17Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "2258.08 1166.68 2171.72 1166.44 2141.56 1166.2 2139.54 1164.19 2139.54 1162.71 2139.61 1159.48 2142.92 1159.36 2200.5 1158.99 2258.07 1158.89 2344.44 1159.15 2376.49 1159.43 2376.57 1166.09 2373.2 1166.17 2315.66 1166.57 2258.08 1166.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M2839.13,1584.13H2675.66a.45.45,0,0,1,0-.89h163.47a.45.45,0,0,1,0,.89Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M2839.13,1587.43H2675.66a3.74,3.74,0,0,1,0-7.48h163.47a3.74,3.74,0,0,1,0,7.48Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 2298.59,
    cy: 850.97,
    r: 221.9,
    transform: "translate(-423.68 1502.08) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M2346.34,916.66H2217.11a7.58,7.58,0,0,1-7.38-5.84,12.88,12.88,0,0,0-1-2.89l-.15-.32a20.42,20.42,0,0,0-1.86-3.32,23.39,23.39,0,0,0-19.38-10.35,23.71,23.71,0,0,0-19.48,10.35,20.84,20.84,0,0,0-1.86,3.32l-.15.32a13,13,0,0,0-1,2.88,7.58,7.58,0,0,1-7.38,5.85h-6.46a12.14,12.14,0,0,1-12.12-12.12V789.84a12.13,12.13,0,0,1,12.12-12.12h195.4a12.13,12.13,0,0,1,12.13,12.12v114.7A12.14,12.14,0,0,1,2346.34,916.66ZM2222.43,901.5h120.88V792.88H2154V897.81c.42-.71.87-1.41,1.35-2.11a38.57,38.57,0,0,1,63.87,0,35.16,35.16,0,0,1,3.13,5.56Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M2441.62,916.66h-5.55a7.59,7.59,0,0,1-7.38-5.84,12.86,12.86,0,0,0-1-2.89l-.15-.32a20.42,20.42,0,0,0-1.86-3.32,23.5,23.5,0,0,0-39,0,19.69,19.69,0,0,0-1.86,3.32l-.15.32a13,13,0,0,0-1,2.88,7.57,7.57,0,0,1-7.38,5.85h-1.72a12.14,12.14,0,0,1-12.13-12.12V814.83a12.14,12.14,0,0,1,12.13-12.12h19.54c4.9-.22,27.5-.11,44.54,18.13,16.82,18,15.69,40.16,15.11,45.58v38.12A12.14,12.14,0,0,1,2441.62,916.66Zm-35.45-37.88a38.88,38.88,0,0,1,32,16.91c.15.22.3.44.44.66V866a6.69,6.69,0,0,1,.06-.9c.39-3.27,1.7-20.24-11.08-33.91s-29.64-13.49-32.92-13.33h-17.06v73.58A38.8,38.8,0,0,1,2406.17,878.78Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2187.3,947a20.51,20.51,0,0,1-20.49-20.49,20.24,20.24,0,0,1,5-13.24,20.17,20.17,0,0,1,31,0,20.24,20.24,0,0,1,5,13.24A20.46,20.46,0,0,1,2187.3,947Zm0-25.81a4.75,4.75,0,0,0-3.83,1.72,1.64,1.64,0,0,1-.21.25,5,5,0,0,0-1.29,3.35,5.28,5.28,0,1,0,10.56,0,5,5,0,0,0-1.29-3.35l-.21-.25A4.69,4.69,0,0,0,2187.3,921.2Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M2406.17,947a20.51,20.51,0,0,1-20.48-20.49,20.22,20.22,0,0,1,5-13.24,20.27,20.27,0,0,1,31,0,20.22,20.22,0,0,1,5,13.24A20.51,20.51,0,0,1,2406.17,947Zm0-25.81a4.86,4.86,0,0,0-3.82,1.72l-.21.25a5,5,0,0,0-1.29,3.35,5.33,5.33,0,1,0,10.65,0,5,5,0,0,0-1.29-3.35,2.52,2.52,0,0,1-.21-.25A4.88,4.88,0,0,0,2406.17,921.2Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 999.18,
    cy: 430.25,
    r: 220.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1483.67,755.65h71.69a9.81,9.81,0,0,0,9.8-9.8V701a9.81,9.81,0,0,0-9.8-9.8h-71.69a9.81,9.81,0,0,0-9.8,9.8v44.82A9.81,9.81,0,0,0,1483.67,755.65Zm4.86-14.65V705.88h62V741Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1670.86,789.06a16.09,16.09,0,0,0-14-8.24H1617.5v-9.94a9.82,9.82,0,0,0-9.8-9.8H1536a9.82,9.82,0,0,0-9.8,9.8v41.54l-5.84,0V770.88a9.82,9.82,0,0,0-9.8-9.8h-71.69a9.82,9.82,0,0,0-9.8,9.8v42.26l-85,.66a15.4,15.4,0,0,0-12.56,24.09l34.76,50.58A34.82,34.82,0,0,0,1395,903.56h199.19A29.17,29.17,0,0,0,1619,889.77l51.48-84.3A16.14,16.14,0,0,0,1670.86,789.06Zm-130,23.25V775.74h62v5.09h-19.32a27.17,27.17,0,0,0-22.35,11.76l-13.55,19.66Zm-97.13-36.57h62v36.83l-60.58.44h-1.39Zm214.27,22-51.47,84.27a14.56,14.56,0,0,1-12.39,6.85H1395a20.18,20.18,0,0,1-16.61-8.74l-34.72-50.53a.69.69,0,0,1-.05-.8.61.61,0,0,1,.61-.37l101-.79,76.64-.55,11.72-.1h0l18-.14a7.36,7.36,0,0,0,6-3.17l15.72-22.8a12.5,12.5,0,0,1,10.28-5.43h73.29a1.36,1.36,0,0,1,1.26.74A1.43,1.43,0,0,1,1658,797.78Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 515.06,
    cy: 1070.9,
    r: 214.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1127.41,1437.05H965a7.81,7.81,0,1,1,0-15.62h162.37a7.81,7.81,0,0,1,0,15.62Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1015.9,1541.84c-4.32,0-7.81-5.75-7.81-12.85V1390.25c0-7.1,3.49-12.85,7.81-12.85s7.8,5.75,7.8,12.85V1529C1023.7,1536.09,1020.21,1541.84,1015.9,1541.84Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1075.23,1541.84c-4.32,0-7.81-5.75-7.81-12.85V1390.25c0-7.1,3.49-12.85,7.81-12.85s7.8,5.75,7.8,12.85V1529C1083,1536.09,1079.54,1541.84,1075.23,1541.84Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1122.44,1491.69H965.92c-4.8,0-8.69-3.49-8.69-7.8s3.89-7.81,8.69-7.81h156.52c4.81,0,8.7,3.5,8.7,7.81S1127.25,1491.69,1122.44,1491.69Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1131.14,1546.62H960a10.08,10.08,0,0,1-10.08-10.09V1382A10.08,10.08,0,0,1,960,1371.91h171.16a10.09,10.09,0,0,1,10.09,10.09v154.53A10.09,10.09,0,0,1,1131.14,1546.62Zm-161.07-20.17h151V1392.08h-151Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M960,1546.62h-73.2a10.1,10.1,0,0,1-10-11l19.81-206.24a10.08,10.08,0,0,1,10-9.12H942a10.08,10.08,0,0,1,10,9.21l18,206.23a10.08,10.08,0,0,1-10,11Zm-62.1-20.17H949l-16.27-186.07h-17Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M2432.31,3088V2715.35a89.28,89.28,0,0,1,88.3-89.33c146.94-1.6,450-1.68,697.94,19.22a67.12,67.12,0,0,1,61.38,64.51L3303.11,3070a85.3,85.3,0,0,1-83.64,88.37l-701.82,13.34A83.75,83.75,0,0,1,2432.31,3088Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M2833.42,2943.32l100.87,10.88a22.73,22.73,0,0,0,25.12-24.27l-22-300.06c-42.29-1.34-84-2.32-124.24-3v293.85A22.73,22.73,0,0,0,2833.42,2943.32Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2874.77,2891.32a10.14,10.14,0,0,0,10.12,9.55c.19,0,.39,0,.59,0a10.13,10.13,0,0,0,9.54-10.71l-15.21-261.88c-6.82-.17-13.59-.32-20.35-.47Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M2550.11,2587.72V2326a62.7,62.7,0,0,1,62-62.73c103.18-1.12,316-1.18,490.14,13.49a47.16,47.16,0,0,1,43.11,45.31l16.27,253a59.91,59.91,0,0,1-58.73,62.06l-492.87,9.36A58.81,58.81,0,0,1,2550.11,2587.72Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M2831.8,2486.11l70.84,7.64a16,16,0,0,0,17.64-17L2904.8,2266c-29.7-.94-59-1.63-87.25-2.11v206.36A16,16,0,0,0,2831.8,2486.11Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M2860.84,2449.59a7.12,7.12,0,0,0,7.1,6.71h.42a7.13,7.13,0,0,0,6.7-7.53l-10.68-183.91-14.29-.33Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2418.23,2031.94l-37.63-45a48.49,48.49,0,0,1-9.46-43.82,517.92,517.92,0,0,0,17.5-116.78,48.53,48.53,0,0,1,21.92-39.17l49.23-32a58,58,0,0,0,24.71-62.62L2466.68,1621a58,58,0,0,0-51.15-43.77l-58.46-5.18a48.55,48.55,0,0,1-37.7-24.35,517.11,517.11,0,0,0-70.14-95,48.47,48.47,0,0,1-12.15-43.15l12.2-57.35a58,58,0,0,0-26.81-61.75l-63.27-38.08a58,58,0,0,0-67.12,5.22l-45,37.63a48.49,48.49,0,0,1-43.82,9.46,517.75,517.75,0,0,0-116.78-17.5,48.5,48.5,0,0,1-39.16-21.92l-32-49.23a58,58,0,0,0-62.62-24.71l-71.67,17.82a58,58,0,0,0-43.77,51.15l-5.18,58.45a48.5,48.5,0,0,1-24.35,37.71,517.79,517.79,0,0,0-95,70.14,48.47,48.47,0,0,1-43.15,12.15l-57.34-12.2a58,58,0,0,0-61.75,26.81l-38.08,63.27a58,58,0,0,0,5.21,67.12l37.64,45a48.45,48.45,0,0,1,9.45,43.81,517.9,517.9,0,0,0-17.49,116.78,48.5,48.5,0,0,1-21.92,39.17l-49.24,32a58,58,0,0,0-24.7,62.63l17.81,71.67a58,58,0,0,0,51.15,43.77l58.46,5.18a48.51,48.51,0,0,1,37.71,24.35,517.74,517.74,0,0,0,70.13,95,48.5,48.5,0,0,1,12.16,43.15l-12.21,57.34a58,58,0,0,0,26.81,61.75l63.28,38.08a58,58,0,0,0,67.11-5.21l45-37.64a48.49,48.49,0,0,1,43.82-9.45,517.9,517.9,0,0,0,116.78,17.49,48.52,48.52,0,0,1,39.17,21.92l32,49.24a58,58,0,0,0,62.62,24.7l71.67-17.81a58,58,0,0,0,43.77-51.15l5.18-58.46a48.56,48.56,0,0,1,24.35-37.71,517.4,517.4,0,0,0,95-70.13,48.5,48.5,0,0,1,43.15-12.16l57.35,12.21a58,58,0,0,0,61.75-26.81l38.08-63.28A58,58,0,0,0,2418.23,2031.94Zm-733.64,164.55c-214.66-101.27-306.57-357.39-205.29-572s357.39-306.56,572-205.29,306.57,357.39,205.3,572.05S1899.25,2297.77,1684.59,2196.49Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M862.85,2658l3.65,67.18s-20.88,224.84-25.25,324.38a78,78,0,0,0,11.54,44.33l42.72,69.37-108.57-64.07L784.78,3086l17.77-24.43-23.28-278.78a85.54,85.54,0,0,1,9.74-47.31l22.45-42.19Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M902.66,3173.35H868a20.85,20.85,0,0,1-16.56-8.12c-10.8-14-33.18-41.41-43.88-42.13-14.41-1-12.56,50.25-12.56,50.25h-8.08l-10.23-63.63a37.67,37.67,0,0,1,19.77-39.38h0s3.29,24.35,21.15,35.12,72.66,49.35,72.66,49.35a49.26,49.26,0,0,1,14.08.38C915.3,3157.16,913.77,3173.35,902.66,3173.35Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M769.49,2658l7.34,43.16s-24.57,248.86-28.94,348.4a78,78,0,0,0,11.54,44.33l42.72,69.37-108.57-64.07L691.42,3086l17.77-24.43-23.28-278.78a85.63,85.63,0,0,1,9.74-47.31l22.46-42.19Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M809.3,3173.35H774.66a20.87,20.87,0,0,1-16.56-8.12c-10.8-14-33.18-41.41-43.88-42.13-14.41-1-12.56,50.25-12.56,50.25h-8.08l-10.23-63.63a37.67,37.67,0,0,1,19.77-39.38h0s3.29,24.35,21.15,35.12,72.66,49.35,72.66,49.35a49.26,49.26,0,0,1,14.08.38C821.94,3157.16,820.41,3173.35,809.3,3173.35Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M840.4,1945.22s15.82-.12,42.49,17.09S957.6,2028,957.6,2028l-48.51-134.58,35.6-9.17s89.66,162.69,72.82,191.21-103.19,20.67-147.21-54.1C847.33,1966.49,840.4,1945.22,840.4,1945.22Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M646.39,1992.06c-4.06,3.16,67.38,154.58,67.53,277.86,0,0,68.56,14.92,125.7-12.26,0,0,55.94-165.57,53.91-185-2.31-22.07-46.7-126.84-46.7-126.84S746.73,1914.19,646.39,1992.06Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M882.87,2153.34a20.18,20.18,0,0,0-14.66-9.57l-59.4-7.79s-2.59-6.7,8.39-14.52,4.61-20.75,4.61-20.75-14.69,11.88-36,30.2c-12.17,10.48-16.86,24.66-18.65,34.88l18.55,14.65c35.74,1.43,69.8-5.31,102.64-18Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M646.39,1992.06s-113.29,101.37-66,225.37,215.15-44.24,215.15-44.24l-12.71-29.5S670.76,2210,642.8,2185c-20.51-18.37,15.73-83.1,36.5-116.3a33.58,33.58,0,0,0-2.36-39Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M889.77,1896.75s-12.35-6.74-17-15.5-17.71-17.72-11.59-20.34,6.8-4.08,14.68,5S920.75,1903.39,889.77,1896.75Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M892.22,1808a6.26,6.26,0,0,0-9.59-.84l-32.72,33a3.55,3.55,0,0,0-.25,4.72l74.3,92.34a1.92,1.92,0,0,0,2.71.29l30.82-25.27a6.26,6.26,0,0,0,1.17-8.41Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M885.11,1820.61a3.54,3.54,0,0,0-5.45-.37l-21.17,22.28a3.55,3.55,0,0,0-.19,4.67l63.35,78.59a1.92,1.92,0,0,0,2.79.21L945,1907.11a1.9,1.9,0,0,0,.26-2.52Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M869.2,1827.53c.25.26.06.86-.44,1.34l-7.3,7.09c-.5.48-1.11.66-1.36.4l-.24-.25c-.26-.26-.06-.87.44-1.35l7.3-7.09c.5-.48,1.1-.66,1.36-.4Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M915.69,1823.68c-6.18,1.34-26.76-9.39-25.09-2.62s9.2,12.72,9.91,15.6,3.67,19.5,10,24c4.54,3.26,16,14.87,22,21.09a6.06,6.06,0,0,0,10-6.36C942.13,1874.32,921.87,1822.34,915.69,1823.68Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M774,1854.77s-11.94,62.06-21.22,89.32a16.53,16.53,0,0,0,8.69,20.35c8.77,4,22,6.84,40.4,2.31a17.55,17.55,0,0,0,13.26-16.8l1-67.63Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M851.8,1786.16s19.33,24.88,16.05,71.12-25.6,55.93-43.05,49.2-41.41-20.61-53.72-58.56S826,1755.05,851.8,1786.16Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M799.2,1838s10.89-64.24,58.71-38.28l6.8,14.07s34-19.93,13.39-50.11-70.36-41.46-104.1-9.77-40.55,60.55-30.64,90.32,30,13.54,30,13.54-1.36-23.41,8.29-30.11,13.76,10.21,13.76,10.21Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M790.54,1841s5.79-33-13.25-29.23-3.8,31.34,2.72,41.16Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M763.33,1779.43c10.18-4,11.07-18.07,1.91-24-29.58-19.27-80.35-36-131.36,22.88-57.46,66.37-89.66,98-108,97.82-12.05-.11-19,13.57-11,22.59,5.91,6.66,16,12.62,32.69,16.12C676.38,1941.77,703.6,1802.81,763.33,1779.43Z",
    transform: "translate(-495.2 -372.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M652.09,2374.16c5.91-47.59,61.83-104.24,61.83-104.24,88.91,13.29,130.81-17.37,130.81-17.37s18.68,62.71,18.92,111.75,9.7,364.82,9.7,364.82c-87,36.47-196.22,16.35-196.22,16.35C683.85,2632.11,646.18,2421.76,652.09,2374.16Z",
    transform: "translate(-495.2 -372.51)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInBanner);
export default __webpack_public_path__ + "static/media/in-banner.ba06e3b050a4446f8b921f5c7f0c1405.svg";
export { ForwardRef as ReactComponent };